import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import verticalBoxGroupIcon from 'assets/images/icons/vertical-box-group.svg';
import sectionIcon from 'assets/images/icons/section.svg';
import sectionCollapseIcon from 'assets/images/icons/section-collapse.svg';
import SwappingComponent from './SwappingComponent';

const SupervisorSectionComponent = ({
  section,
  direction,
  selectComponent,
  changeFormElementOrder,
  isSelected,
  elementIndex,
  checkSwapArrow,
  isSecExistsInOtherSecWorkflow,
}) => {
  const { t } = useTranslation();

  return (
    <div className={`fields-section-new ${isSelected ? 'selected' : ''}`}>
      <div className='fields-section-header'>
        <div
          className='d-flex gap-2 align-items-center cursor-pointer'
          onClick={() => selectComponent(elementIndex, section.elementType)}
        >
          <img
            src={sectionCollapseIcon}
            className={`${isSelected ? '' : `rotate-${direction === 'rtl' ? '90' : '270'}`}`}
          />
          <label
            className='cursor-pointer'
            style={{
              color: section.properties?.basicProperties?.sectionTitleColor,
              fontSize: section.properties?.basicProperties?.sectionTitleSize,
            }}
          >
            {section.properties?.basicProperties?.sectionTitle
              ? section.properties?.basicProperties?.sectionTitle
              : t('form_untitled_section')}
          </label>
        </div>
        <div
          className='flex-grow-1 text-center cursor-pointer'
          onClick={() => selectComponent(elementIndex, section.elementType)}
        >
          <label className='theme-text-white-1 cursor-pointer'>
            {isSelected ? 'Click to close section' : 'Click to open section'}
          </label>
        </div>
        <div className='d-flex gap-2'>
          <div className='element-icon'>
            <img src={sectionIcon} className='svg-white' />
          </div>
          <SwappingComponent
            elementType='supervisor_section'
            elementIcon={verticalBoxGroupIcon}
            type='supervisor_section'
            props={{ position: elementIndex }}
            changeFormElementOrder={changeFormElementOrder}
            {...checkSwapArrow(elementIndex, section.elementType, 'supervisor-field')}
            isSecExistsInOtherSecWorkflow={isSecExistsInOtherSecWorkflow}
          />
        </div>
      </div>
    </div>
  );
};

SupervisorSectionComponent.propTypes = {
  section: PropTypes.object.isRequired,
  direction: PropTypes.string.isRequired,
  selectComponent: PropTypes.func.isRequired,
  changeFormElementOrder: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  elementIndex: PropTypes.number.isRequired,
  checkSwapArrow: PropTypes.func.isRequired,
  isSecExistsInOtherSecWorkflow: PropTypes.func.isRequired,
};

export default SupervisorSectionComponent;
